<template>
  <CFooter :fixed="false">
    <div>
      <a href="#" target="_blank">Hệ thống tập trung</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} - {{new Date().getFullYear() + 1}}</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="#" target="_blank">Team NEWTATCO</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
